export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20product%20photography%20background%20with%20white%20sneakers%20and%20neutral%20tone%20accessories%20elegantly%20arranged%20on%20a%20light%20cream%20surface%2C%20diffused%20natural%20window%20light%2C%20clean%20aesthetic%20with%20organic%20textures%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20editorial%20fashion%20lifestyle%20photography%2C%20soft%20shadows%2C%20harmonious%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="CSSBuy spreadsheet directory - curated shopping agent resources and product spreadsheets"
        title="CSSBuy Sheet - Shopping Agent Spreadsheet Resource Directory"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-xs font-medium text-background-50">Free Spreadsheet Resource Directory</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
              The Ultimate CSSBuy Spreadsheet Directory
            </h1>

            <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-xl">
              Curated shopping agent resources for shoes, hoodies, jackets and more. All verified seller links lead to trusted spreadsheets on kaspreadsheet.com.
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50/15 text-background-50 font-semibold text-sm border border-background-50/30 hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                Buy It Now
                <i className="ri-shopping-bag-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-1 text-background-50/60 text-xs">
          <span>Scroll to explore</span>
          <i className="ri-arrow-down-line animate-bounce text-sm"></i>
        </div>
      </div>
    </section>
  );
}